
function getMetaTagContent(name) {
  const metaTag = document.querySelector('meta[name="' + name + '"]');
  return metaTag ? metaTag.getAttribute('content') : '';
}

document.addEventListener('DOMContentLoaded', () => {
  const ldScripts = document.querySelectorAll('script[type="application/ld+json"]');
  ldScripts.forEach(function(script) {
    const ldJson = JSON.parse(script.textContent);
    ldJson['@graph'].forEach(function(item) {
      if (item['@type'] === 'WebPage') {
        item['name'] = document.title;
        item['description'] = getMetaTagContent('description');
      }
    });
    script.textContent = JSON.stringify(ldJson);
  });
})